// extracted by mini-css-extract-plugin
module.exports = {"container":"CardsContainer_container__sj1FW"};